export default `query {
  allProducts(filter: {limitedEdition: {eq: true}}) {
    sku
    stockManagedPart
    hidden
    lensTechnology
    landingPageLinkCopy
    showLinkToLandingPage
    stockManagedPart
    swatchIconOverride {
      url(imgixParams: {w: "50", h: "50"})
    }
    landingPage {
      _status
      slug
      products {
        sku
      }
    }
  }
}`
